import API from './apiConfig';

export const userLogin = async (credentials) => {
  try {
    const response = await API.post('/login', credentials);
    const data = response?.data?.data;
    if (data?.access_token) {
      localStorage.setItem("user_id", JSON.stringify(data.user.user_id));
      localStorage.setItem("participant_id", JSON.stringify(data.user.id));
      localStorage.setItem("participation_type", JSON.stringify(data.user.participation_type));
      localStorage.setItem("retreat_language", JSON.stringify(data.user.retreat_language));
      localStorage.setItem("token", JSON.stringify(data.access_token));
    }
    return response;
  } catch (error) {
    throw error;
  }
};

export const onlineLogin = async (credentials) => {
  try {
    const response = await API.post('/login', credentials);
    if (response.data?.access_token) {
      localStorage.setItem("token", JSON.stringify(response.data.access_token));
      localStorage.setItem("username", JSON.stringify(response.data.username));
      localStorage.setItem("participation_type", "true");
      return response;
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};
